var map = {
	"./2024-01_student-success.jpg": "92d1",
	"./2024-02_research-community.jpg": "d925",
	"./2024-04_experiential-learning.jpg": "c4df",
	"./2024-05_commencement.jpg": "71d3",
	"./2024-05_impact.jpg": "7404",
	"./2024-07_we-are-georgia.png": "d662",
	"./2024-08_faculty-achievements.jpg": "3e89",
	"./2024-09_academic-excellence.jpg": "c52e",
	"./2024-11_research.jpg": "10e8",
	"./2024-12_commencement.jpg": "e08c",
	"./2025-01_student-success.webp": "2c79",
	"./2025-02_impact.webp": "0531",
	"./2025-03_experiential-learning.webp": "8b8e",
	"./2025-05_commencement.webp": "995a",
	"./2025-05_research-innovation-global-impact.webp": "189c",
	"./2025-07_student_experience.webp": "5b1f",
	"./2025-09_academic-excellence.webp": "89cb",
	"./2025-12_commencement.webp": "b0a8",
	"./2025-12_student-success.jpg": "e814",
	"./2026-02_school-of-medicine.webp": "f549",
	"./2026-04_career-outcomes.jpg": "2056",
	"./2026-05_commencement.webp": "598b",
	"./2026-06_research-and-innovation.webp": "3cd4",
	"./2026_01_student-success.webp": "d83c",
	"./career-readiness-cover.jpg": "953a",
	"./champions-poster.png": "fb4a",
	"./economic-impact.png": "cf33",
	"./placeholder-spring-commencement-23.jpg": "0ecf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa69";